import React from "react";
import styled from "styled-components";

import HSpace from "../layout/HSpace";

const Styled = styled(HSpace)`
  color: #777;
  font-size: 1.8rem;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  gap: 1.5rem;

  // we want NoResults to be the same height as Loading
  min-height: 6.4rem;

  svg {
    width: 4rem;
    fill: currentColor;
  }
`;

const LargePlaceholder: React.FC<
  React.PropsWithChildren<{
    icon?: React.ReactNode;
    className?: string;
  }>
> = (props) => {
  return (
    <Styled className={props.className}>
      {!!props.icon && <div>{props.icon}</div>}
      <div>{props.children}</div>
    </Styled>
  );
};

export default LargePlaceholder;
